module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kh-La.1b15522a.png";